export default __webpack_public_path__ + "static/media/Rpm.cee07e14.svg";